import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_RAV2_HOMEWORK_RESULT_SUMMARY_REQUEST = 'FETCH_RAV2_HOMEWORK_RESULT_SUMMARY_REQUEST';
export const FETCH_RAV2_HOMEWORK_RESULT_SUMMARY_SUCCESS = 'FETCH_RAV2_HOMEWORK_RESULT_SUMMARY_SUCCESS';
export const FETCH_RAV2_HOMEWORK_RESULT_SUMMARY_FAILURE = 'FETCH_RAV2_HOMEWORK_RESULT_SUMMARY_FAILURE';

const method = 'GET';
const buildRAv2HomeworkResultSummaryUrl = (groupId) =>
  buildUrl(`/ra-v2-groups/${groupId}/homework-result-summary`);

export function fetchRAv2HomeworkResultSummaryIfNeeded(groupId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, {
      method,
      url: buildRAv2HomeworkResultSummaryUrl(groupId),
    })) {
      return false;
    }

    return dispatch(fetchRAv2HomeworkResultSummary(groupId));
  };
}

export function fetchRAv2HomeworkResultSummary(groupId) {
  return (dispatch) => {
    const url = buildRAv2HomeworkResultSummaryUrl(groupId);

    return dispatch(fetchRAv2HomeworkResultSummaryRequest()).payload
      .then((response) => dispatch(fetchRAv2HomeworkResultSummarySuccess(response)))
      .catch((error) => {
        if (error.response && error.response.code === 404) {
          return dispatch(fetchRAv2HomeworkResultSummarySuccess([]));
        }

        return dispatch(fetchRAv2HomeworkResultSummaryFailure(error));
      });

    function fetchRAv2HomeworkResultSummaryRequest() {
      return ApiCall.createAction({
        type: FETCH_RAV2_HOMEWORK_RESULT_SUMMARY_REQUEST,
        payload: fetch(url),
        url,
        method,
        groupId,
      });
    }

    function fetchRAv2HomeworkResultSummarySuccess(payload) {
      return ApiCall.createAction({
        type: FETCH_RAV2_HOMEWORK_RESULT_SUMMARY_SUCCESS,
        payload,
        url,
        method,
        groupId,
      });
    }

    function fetchRAv2HomeworkResultSummaryFailure(error) {
      return ApiCall.createAction({
        type: FETCH_RAV2_HOMEWORK_RESULT_SUMMARY_FAILURE,
        error,
        url,
        method,
        groupId,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/RAv2HomeworkResultSummary/actions.js